Vendd.Scripts.load(function () {

    var Vendd = window.Vendd || {};

    var formControlBase = function (element, definition) {

        Vendd.inlineEdit.containerControlBase.apply(this, [element, definition]);

    };
    formControlBase.prototype = Object.create(Vendd.inlineEdit.containerControlBase.prototype);
    formControlBase.prototype.name = 'formControlBase';

    formControlBase.prototype.hasChanges = function () {

        throw new Error('Not Implemented');

    };

    formControlBase.prototype.discard = function () {

        throw new Error('Not Implemented');

    };

    formControlBase.prototype.save = function () {

        throw new Error('Not Implemented');

    };

    formControlBase.prototype.findControl = function (lambda) {

        var self = this;

        if (typeof lambda === 'string') {

            return self.findControl(function (x) { return x.definition.id === lambda });

        }

        var flatternTree = function (node) {

            var result = [node];

            if (_.isArray(node.controls)) {

                _.each(node.controls, function (childNode) {

                    result = result.concat(flatternTree(childNode));

                });

            }

            return result;
        }

        var allNodes = flatternTree(self);

        return _.find(allNodes, lambda);

    }

    Vendd.inlineEdit.controls = {}
    Vendd.inlineEdit.formControlBase = formControlBase;

});